import z from 'zod'
import type { GrantType } from '@/tools/auth'

const VirtualBalanceSchema = z.object({
  balance: z.number(),
})

const PermissionSchema = z.object({
  type: z.string(),
  title: z.string(),
  enabled: z.boolean(),
})

const PhoneNumberSchema = z.object({
  countryCode: z.string().nullish(),
  number: z.string(),
})
export const CompanyDetailsSchema = z.object({
  addressLine1: z.string(),
  addressLine2: z.string().nullish(),
  city: z.string(),
  countryCode: z.string(),
  name: z.string(),
  postalCode: z.string(),
  province: z.string(),
  taxId: z.string(),
})

export const UserModelSchema = z.object({
  id: z.number(),
  type: z.literal('Customer'),
  urn: z.string(),
  name: z.string(),
  picture: z.string().nullish(),
  email: z.string().email(),
  description: z.string().nullish(),
  facebookId: z.string().nullish(),
  preferredCityCode: z.string().nullish(),
  preferredLanguage: z.string(),
  preferredLanguageRegion: z.string(),
  locale: z.string(),
  deviceUrn: z.string().nullish(),
  analyticsId: z.string().nullish(),
  mediaCampaign: z.string().nullish(),
  mediaSource: z.string().nullish(),
  os: z.string().nullish(),
  deliveredOrdersCount: z.number(),
  phoneNumber: PhoneNumberSchema.nullish(),
  companyDetail: CompanyDetailsSchema.nullish(),
  virtualBalance: VirtualBalanceSchema.nullish(),
  freeOrders: z.number().nullish(),
  paymentMethod: z.enum(['CREDIT_CARD', 'GLOVO_CREDIT', 'CASH', 'OTHER']),
  paymentWay: z.string().nullish(),
  currentCard: z.string().nullish(),
  accumulatedDebt: z.number(),
  defaulter: z.boolean().nullish(),
  gender: z.string().nullish(),
  ageMin: z.number().nullish(),
  ageMax: z.number().nullish(),
  birthday: z.string().nullish(),
  privacySettings: z.string().nullish(),
  permissions: z.array(PermissionSchema),
  dataPrivacyEnabled: z.boolean(),
})

export type UserModel = z.infer<typeof UserModelSchema>
export type CompanyDetails = z.infer<typeof CompanyDetailsSchema>
export type Permission = z.infer<typeof PermissionSchema>
export type PhoneNumber = z.infer<typeof PhoneNumberSchema>

export interface CreateUserPayload {
  name: string
  email: string
  phoneNumber?: string
  identityFlowId?: string
  token?: string
  grantType: GrantType
  vendorUserId?: string
  preferredLanguage?: string
  facebookId?: string
}

export type UserPassword = string
